import styled from '@emotion/styled';
import { Pagination as MUIPagination } from '@mui/material';
import tw from 'twin.macro';

const StyledMUIPagination = styled(MUIPagination)`
  & .MuiPaginationItem-root,
  & .MuiButtonBase-root {
    ${tw`text-[14px]/[20px] m-1 p-0 min-w-6 h-6 text-base-800`}

    &.Mui-selected {
      ${tw`font-medium text-brand-900 bg-brand-300/20`}
    }

    &.Mui-disabled {
      ${tw`text-base-400 opacity-100`}
    }

    & .MuiTouchRipple-root {
      ${tw`hidden`}
    }
  }
`;

export const Pagination = ({ onChange, ...props }) => {
  return (
    <StyledMUIPagination
      {...props}
      onChange={(_e, nextPage) => {
        onChange(nextPage);
      }}
    />
  );
};
